import { useState, useRef } from "react";
import { Upload, X, Image } from "lucide-react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export default function ImageUploader({ value, onChange, label = "Görsel" }) {
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const token = localStorage.getItem("bct_token");
      const { data } = await axios.post(`${API}/api/upload`, formData, {
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
        withCredentials: true,
      });
      onChange(data.url);
    } catch {
      alert("Yükleme hatası");
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  return (
    <div>
      <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">{label}</label>
      <div className="space-y-2">
        {value && (
          <div className="relative inline-block">
            <img src={value.startsWith("/api") ? `${API}${value}` : value} alt="" className="h-24 w-auto rounded-lg object-cover border border-white/10" />
            <button onClick={() => onChange("")} className="absolute -top-2 -right-2 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center">
              <X size={10} className="text-white" />
            </button>
          </div>
        )}
        <div className="flex gap-2">
          <input type="text" value={value} onChange={(e) => onChange(e.target.value)} placeholder="URL yapıştır veya yükle" className="admin-input flex-1" data-testid={`image-url-${label}`} />
          <label className={`flex items-center gap-1.5 px-3 py-2 bg-white/5 border border-white/10 rounded-xl text-sm cursor-pointer hover:bg-white/10 transition-colors ${uploading ? "opacity-50 pointer-events-none" : ""}`}>
            <Upload size={14} className="text-[#FF5A00]" />
            <span className="text-slate-400 text-xs">{uploading ? "..." : "Yükle"}</span>
            <input ref={fileRef} type="file" accept="image/*" onChange={handleUpload} className="hidden" />
          </label>
        </div>
      </div>
    </div>
  );
}
